import { render, staticRenderFns } from "./FrinkRecommendCRMReports.vue?vue&type=template&id=4ccc151c&scoped=true"
import script from "./FrinkRecommendCRMReports.vue?vue&type=script&lang=js"
export * from "./FrinkRecommendCRMReports.vue?vue&type=script&lang=js"
import style0 from "./FrinkRecommendCRMReports.vue?vue&type=style&index=0&id=4ccc151c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc151c",
  null
  
)

export default component.exports